"use strict";

var Immutable = require('immutable'),
    FacetedClassification = require('./classification');

var FacetSelection = Immutable.Record({
  name: null,
  values: Immutable.Set()
});

function FacetedQuery(facetedClassification) {
  var selections = arguments.length <= 1 || arguments[1] === undefined ? Immutable.List() : arguments[1];

  if (!(this instanceof FacetedQuery)) {
    return new FacetedQuery(facetedClassification, selections);
  }

  if (!(facetedClassification instanceof FacetedClassification)) {
    throw new Error('Must pass a FacetedClassification object to FacetedQuery.');
  }

  this.facetedClassification = facetedClassification;
  this.selections = selections;
}

Object.assign(FacetedQuery.prototype, {
  select: function select(_ref) {
    var name = _ref.name;
    var values = _ref.values;

    if (!this.facetedClassification.facetsByIndex().has(name)) {
      throw new Error('No such facet: ' + name);
    }

    return new FacetedQuery(this.facetedClassification, this.selections.push(new FacetSelection({
      name: name,
      values: Immutable.Set(values)
    })));
  },
  deselect: function deselect(_ref2) {
    var name = _ref2.name;
    var values = _ref2.values;

    return new FacetedQuery(this.facetedClassification, this.selections.delete(new FacetSelection({
      name: name,
      values: Immutable.Set(values)
    })));
  },
  reset: function reset(name) {
    return new FacetedQuery(this.facetedClassification, name ? this.selections.filter(function (selection) {
      return selection.name !== name;
    }) : this.selections.clear());
  },
  selectedFacetsByIndex: function selectedFacetsByIndex(returnedFields) {
    var _this = this;

    var selectedItemsByIndex = this.selectedItemsByIndex(),
        fields = returnedFields || this.facetedClassification.facetsByIndex().keySeq();

    return Immutable.Map().withMutations(function (map) {
      fields.forEach(function (name) {
        var facet = _this.facetedClassification.facetsByIndex().get(name);

        map.set(name, _this.selections.size === 0 ? facet : facet.map(function (indices) {
          return indices.intersect(selectedItemsByIndex);
        }).filter(function (indices) {
          return indices.size;
        }));
      });
    });
  },
  selectedFacets: function selectedFacets(returnedFields) {
    var _this2 = this;

    return this.selectedFacetsByIndex(returnedFields).map(function (facet) {
      return facet.map(function (indices) {
        return indices.map(function (i) {
          return _this2.facetedClassification.items.get(i);
        });
      });
    });
  },
  selectedFacetValues: function selectedFacetValues() {
    return this.selectedFacetsByIndex().map(function (facet) {
      return facet.keySeq().toSet();
    });
  },
  selectedItemsByIndex: function selectedItemsByIndex() {
    var _this3 = this;

    return this.selections.size === 0 ? this.facetedClassification.items.keySeq() : this.selections.map(function (_ref3) {
      var name = _ref3.name;
      var values = _ref3.values;
      return _this3.facetedClassification.facetsByIndex().get(name).filter(function (indices, facetValue) {
        return values.contains(facetValue);
      }).toSet().flatten();
    }).reduce(function (prev, next) {
      return prev.intersect(next);
    });
  },
  selectedItems: function selectedItems() {
    var _this4 = this;

    return this.selectedItemsByIndex().map(function (id) {
      return _this4.facetedClassification.items.get(id);
    });
  }
});

module.exports = FacetedQuery;